import React, { useState, useEffect } from "react";

const UploadPhoto = ({ defaultProfileIcon, cameraIcon, formData, type, uploadUserPhoto, addStoryIcon }) => {
  const [profilePhoto, setProfilePhoto] = useState(formData?.profile || null);

  useEffect(() => {
    if (formData?.profile) {
      setProfilePhoto(formData?.profile);
    }
  });

  const handlePhotoChange = (event) => {
    if (type === 'profile') {
      if (event?.target?.files && event?.target?.files?.length > 0) {
        const file = event?.target?.files[0];
        setProfilePhoto(file);
        uploadUserPhoto(file);
        formData['profile'] = file;
      }
    } else {
      const file = event?.target?.files[0];
      setProfilePhoto(file);
      formData['profile'] = file;
    }
  };

  const getPhoto = () => {
    const profileSrc =
      type === 'profile' && formData?.profile instanceof Blob
        ?  URL.createObjectURL(formData?.profile) 
        : profilePhoto instanceof Blob
          ? URL.createObjectURL(profilePhoto)
          : type === 'profile' ? formData?.profile : profilePhoto;
    
    return profileSrc;
  }

  return (
    <div>

      <label htmlFor="profile-photo">
        <div className="profile-photo-container">
          {formData?.profile && formData?.profile !== '' ? (

            <div className="default-profile-photo shadow">
              <img src={getPhoto()} alt="Profile Photo" className="user-img" />
              {addStoryIcon && (
                <img src={addStoryIcon} alt="Profile Photo" className="camera-icon add-story-icon" />
              )}
            </div>
          ) : (
            <div className="default-profile-photo shadow">
              <img src={defaultProfileIcon} alt="Profile Photo" className="user-img " />
              {addStoryIcon ? (
                <img src={addStoryIcon} alt="Profile Photo" className="camera-icon add-story-icon " />
              ) : (
                <img src={cameraIcon} alt="Profile Photo" className="camera-icon " />
              )}
            </div>
          )}
        </div>
        <input
          type="file"
          id="profile-photo"
          accept="image/*"
          className="d-none"
          onChange={handlePhotoChange}
        />
      </label>
    </div>
  );
}

export default UploadPhoto;